module.exports = "span {\n  margin-left: 5px;\n}\n\n.sign-up-steps {\n  margin: 20px;\n  padding: 20px;\n  background-color: #424242;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/user/signup/signup-steps/signup-steps.component.css
// module id = ./src/app/user/signup/signup-steps/signup-steps.component.css
// module chunks = main